var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4.5625L12.75 10.5625C13.1875 11.5625 12.9375 12.75 12.0625 13.4375L9 16C11.0625 20.375 14.625 23.9375 19 26L21.5625 22.9375C22.25 22.0625 23.4375 21.8125 24.4375 22.25L30.4375 24.75C31.625 25.1875 32.1875 26.5 31.875 27.6875L30.375 33.1875C30.0625 34.25 29.125 35 28 35C12.5 35 0 22.5 0 7C0 5.875 0.75 4.9375 1.8125 4.625L7.3125 3.125C8.5 2.8125 9.8125 3.375 10.25 4.5625Z",
    fill: "#082940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.49aaa20b6f2e68666062a1c5e16d8211.svg";
export { ForwardRef as ReactComponent };